<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <h2 class="primary--text">Consulta de diárias</h2>
                <v-breadcrumbs
                    large
                    :items="crumbs"
                    divider="/"
                    class="pl-0"
                ></v-breadcrumbs>
            </v-col>
        </v-row>
        
        <div style="position: relative;">
            <v-card class="filters-card" outlined>
                <!-- Legenda como chips -->
                <v-card-text class="py-3">
                    <div class="legend">
                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="primary">mdi-cloud</v-icon>
                            Gerado na Web App
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small>mdi-laser-pointer</v-icon>
                            Gerado através ERP
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="warning">mdi-steering</v-icon>
                            Criado por Manobrador
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="black">mdi-account-hard-hat</v-icon>
                            Criado por Encarregado
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="success">mdi-sync</v-icon>
                            Sincronizada
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small>mdi-sync-off</v-icon>
                            Por sincronizar
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="success">mdi-check-decagram</v-icon>
                            Aprovados
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="blue darken-2">mdi-passport-biometric</v-icon>
                            Com KPI
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="success">mdi-toy-brick-outline</v-icon>
                            Integrado no primavera
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="error">mdi-sync-alert</v-icon>
                            Erro na Integração
                        </v-chip>

                        <v-chip small class="mr-2 mb-2" outlined>
                            <v-icon left small color="error">mdi-close-circle-outline</v-icon>
                            Rejeitada
                        </v-chip>
                    </div>
                </v-card-text>

                <v-divider />

                <!-- Filtros -->
                <v-card-text class="py-4">
                    <v-row align="center" class="mx-0" dense>
                        <!-- Por obra -->
                        <v-col cols="12" md="6" lg="5">
                            <div class="field-label mb-1">Por obra</div>

                            <v-autocomplete
                                v-model="filter.work_id"
                                :items="obras_user_tem_acesso"
                                item-value="Id"
                                :item-text="item => item.Codigo + ' - ' + item.Descricao"
                                dense
                                outlined
                                prepend-inner-icon="mdi-account-details"
                                label="Selecionar obra"
                                clearable
                                hide-details
                            />
                        </v-col>

                        <!-- Estado -->
                        <v-col cols="12" md="6" lg="5">
                            <div class="field-label mb-1">Estado</div>

                            <div class="d-flex align-center flex-wrap">
                                <v-checkbox
                                    v-model="filter.approved"
                                    dense
                                    hide-details
                                    class="ma-0 mr-5 premium-checkbox"
                                    label="Apenas aprovadas"
                                    color="success"
                                />

                                <v-checkbox
                                    v-model="filter.show_all"
                                    dense
                                    hide-details
                                    class="ma-0 premium-checkbox"
                                    label="Todas"
                                    color="success"
                                />
                            </div>
                        </v-col>

                        <!-- Botão -->
                        <v-col cols="12" md="auto" class="text-md-right">
                            <v-btn
                                color="primary"
                                class="white--text"
                                rounded
                                depressed
                                @click="searchDiaries"
                            >
                                <v-icon left small>mdi-magnify</v-icon>
                                Pesquisar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-row v-if="false">
                <v-col cols="12" offset="0" md="12" offset-md="0">
                    <v-card tile>
                        <v-card-title class="primary--text">
                            Ver
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-card-text>
                            <v-row>
                                <v-col
                                    cols="12"
                                    md="auto"
                                    v-for="item in choices"
                                    :key="item.id"
                                >
                                    <v-btn
                                        @click="filter.type = item.id; searchDiaries();"
                                        :prepend-icon="item.icon"
                                        :to="'#' + item.id"
                                        class="warning"
                                    >
                                        <v-icon class="mr-2">
                                            {{ item.icon }}
                                        </v-icon>
                                        {{ item.name }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="filter.type != null">
                <v-col cols="12">
                    <v-speed-dial
                        absolute
                        v-model="speedDial"
                        top
                        right
                        direction="bottom"
                        :open-on-hover="true"
                    >
                        <template v-slot:activator>
                            <v-tooltip right color="primary">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        v-model="speedDial"
                                        color="primary"
                                        dark
                                        x-large
                                        fab
                                    >
                                        <v-icon v-if="speedDial">
                                            mdi-close
                                        </v-icon>

                                        <v-icon v-else>
                                            mdi-dots-vertical
                                        </v-icon>
                                    </v-btn>
                                </template>

                                <span>Opções</span>
                            </v-tooltip>
                        </template>

                        <v-tooltip right color="secondary">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    fab
                                    dark
                                    small
                                    color="secondary"
                                    large
                                    @click="searching = true"
                                >
                                    <v-icon>mdi-filter</v-icon>
                                </v-btn>
                            </template>

                            <span>Pesquisar</span>
                        </v-tooltip>
                    </v-speed-dial>

                    <v-data-table
                        :expanded.sync="expanded"
                        show-expand
                        single-expand
                        :headers="headers"
                        :loading="loading"
                        :server-items-length="total"
                        :items="items"
                        :footer-props="tableFooter"
                        :options.sync="options"
                        class="elevation-1"
                        :item-class="rowClass"
                    >
                        <template v-slot:item.responsavel="{ item }">
                            <div class="d-none d-lg-block">
                                <Tooltip
                                    class="my-4 mr-4"
                                    color="primary"
                                    :text="item.approved_by"
                                    top
                                >
                                    {{ item.responsavel }}
                                </Tooltip>
                            </div>

                            <div class="d-md-none">
                                {{ item.responsavel }} - {{ item.approved_by }}
                            </div>
                        </template>

                        <template v-slot:item.chave="{ item }">
                            <Tooltip
                                class="my-4 mr-4"
                                color="primary"
                                :text="item.work_name"
                                top
                            >
                                {{ item.chave }}
                            </Tooltip>
                        </template>

                        <template v-slot:item.creator="{ item }">
                            <div class="d-none d-lg-block">
                                <Tooltip
                                    class="my-4 mr-4"
                                    color="primary"
                                    :text="item.creator_name"
                                    top
                                >
                                    {{ item.creator }}
                                </Tooltip>
                            </div>

                            <div class="d-md-none">
                                {{ item.creator }} - {{ item.creator_name }}
                            </div>
                        </template>

                        <template v-slot:item.approval_status="{ item }">
                            <v-row>
                                <v-col cols="12" md="auto">
                                    <v-icon
                                        small
                                        color="warning"
                                        v-if="item.creation_role == 'manobrador'"
                                    >
                                        mdi-steering
                                    </v-icon>

                                    <v-icon
                                        small
                                        color="black"
                                        v-if="item.creation_role == 'encarregado'"
                                    >
                                        mdi-account-hard-hat
                                    </v-icon>
                                </v-col>

                                <v-col cols="12" md="auto">
                                    <v-tooltip
                                        top
                                        v-if="item.primavera_integrated == '1' || item.primavera_integrated === 1"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                color="success"
                                            >
                                                mdi-toy-brick-outline
                                            </v-icon>
                                        </template>

                                        <span>Integrada no Primavera</span>
                                    </v-tooltip>

                                    <template v-else>
                                        <v-icon
                                            small
                                            color="success"
                                            v-if="checkApprovalStatus(item) == 'total'"
                                        >
                                            mdi-check-decagram
                                        </v-icon>

                                        <span v-else>
                                            {{ checkApprovalStatus(item) }}
                                        </span>
                                    </template>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="auto"
                                    v-if="item.weather != null"
                                >
                                    <v-icon small>
                                        {{ getWeatherIcon(item.weather) }}
                                    </v-icon>
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="item.parque_approved"
                                    md="auto"
                                >
                                    <v-icon small color="error">
                                        mdi-parking
                                    </v-icon>
                                </v-col>

                                <v-col cols="12" md="2" v-if="false">
                                    <v-icon
                                        v-if="item.sincronizada"
                                        color="success"
                                    >
                                        mdi-sync
                                    </v-icon>

                                    <v-icon v-else>
                                        mdi-sync-off
                                    </v-icon>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="auto"
                                    v-if="item.diary_kpi_header_id != null"
                                >
                                    <v-icon color="blue darken-2">
                                        mdi-passport-biometric
                                    </v-icon>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="auto"
                                    v-if="item.integration_error != null"
                                >
                                    <v-icon color="error">
                                        mdi-sync-alert
                                    </v-icon>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="auto"
                                    v-if="isDiaryRejected(item)"
                                >
                                    <v-tooltip top color="error">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                                color="error"
                                            >
                                                mdi-close-circle-outline
                                            </v-icon>
                                        </template>

                                        <span>Diária rejeitada</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-row
                                v-if="item.locked == false && item.status == 'DIARY'"
                                justify="start"
                            >
                                <v-col cols="12" md="auto">
                                    <v-btn
                                        fab
                                        dark
                                        x-small
                                        outlined
                                        color="warning"
                                        @click="edit(item)"
                                    >
                                        <v-icon dark>
                                            mdi-pencil
                                        </v-icon>
                                    </v-btn>
                                </v-col>

                                <v-col cols="12" md="auto">
                                    <v-btn
                                        fab
                                        x-small
                                        outlined
                                        color="blue"
                                        @click="openPreviewDiary(item.id)"
                                    >
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="auto"
                                    v-if="checkIfCanApprove(item) == true || checkIfCanApprove(item) == null"
                                >
                                    <v-btn
                                        fab
                                        dark
                                        x-small
                                        outlined
                                        :color="checkIfCanApprove(item) == null ? 'grey' : 'success'"
                                        @click="confirmApprove(item)"
                                    >
                                        <v-icon dark>
                                            mdi-check-decagram
                                        </v-icon>
                                    </v-btn>

                                    <v-icon color="red">
                                        mdi-warning
                                    </v-icon>
                                </v-col>
                            </v-row>

                            <v-row
                                v-else-if="item.locked == true && item.status == 'DIARY'"
                                justify="center"
                            >
                                <v-col cols="12" align="start">
                                    <v-icon>mdi-lock</v-icon>
                                </v-col>
                            </v-row>

                            <v-row v-else justify="center">
                                <v-col
                                    cols="12"
                                    md="6"
                                    v-if="item.status == 'PROCESSING'"
                                >
                                    <v-progress-linear
                                        color="deep-purple accent-4"
                                        indeterminate
                                        rounded
                                        height="14"
                                        style="min-width: 100px;"
                                    >
                                        <span class="white--text">
                                            A processar
                                        </span>
                                    </v-progress-linear>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="6"
                                    v-if="item.status == 'FAILED'"
                                >
                                    <v-btn
                                        x-small
                                        rounded
                                        class="deep-purple accent-4 white--text"
                                        @click="repeatCreateDiary(item)"
                                    >
                                        Repetir
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </template>

                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length">
                                <v-row>
                                    <v-col cols="12" md="3" align="center">
                                        <v-card class="elevation-0 transparent text-center">
                                            <v-card-text class="text-center">
                                                <span class="font-weight-bold text-body-1">
                                                    <v-icon
                                                        slot="icon"
                                                        color="warning"
                                                        small
                                                        class="mr-2"
                                                    >
                                                        mdi-clipboard-text-clock
                                                    </v-icon>
                                                    Criada a:
                                                </span>
                                                <br />

                                                {{ item.created_at }}
                                                <br />

                                                <strong>
                                                    ({{ item.creator_name }})
                                                </strong>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>

                                    <v-col cols="12" md="3">
                                        <v-card class="elevation-0 transparent text-center">
                                            <v-card-text class="text-center">
                                                <span class="font-weight-bold text-body-1">
                                                    <v-icon
                                                        slot="icon"
                                                        color="warning"
                                                        small
                                                        class="mr-2"
                                                    >
                                                        mdi-swap-horizontal
                                                    </v-icon>
                                                    Modificada a:
                                                </span>
                                                <br />

                                                {{ item.updated_at }}
                                                <br />

                                                <strong>
                                                    ({{ item.modified_by }})
                                                </strong>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>

                                    <v-col cols="12" md="3">
                                        <v-card class="elevation-0 transparent text-center">
                                            <v-card-text class="text-center">
                                                <span class="font-weight-bold text-body-1">
                                                    <v-icon
                                                        slot="icon"
                                                        color="warning"
                                                        small
                                                        class="mr-2"
                                                    >
                                                        mdi-list-status
                                                    </v-icon>
                                                    Aprovada a:
                                                </span>
                                                <br />

                                                {{ item.approved_at }}
                                                <br />

                                                <strong>
                                                    ({{ item.approved_by }})
                                                </strong>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>

                                    <v-col cols="12" md="3" align="end">
                                        <v-card class="elevation-0 transparent text-end">
                                            <v-card-text class="text-end">
                                                <v-row
                                                    no-gutters
                                                    align="end"
                                                    justify="end"
                                                >
                                                    <v-col
                                                        cols="12"
                                                        md="8"
                                                        align="end"
                                                        justify="end"
                                                    >
                                                        <v-btn
                                                            block
                                                            class="primary mb-2"
                                                            rounded
                                                            x-small
                                                            @click="openHistorico(item)"
                                                        >
                                                            <v-icon
                                                                class="mr-2"
                                                                x-small
                                                            >
                                                                mdi-eye
                                                            </v-icon>
                                                            Histórico edições
                                                        </v-btn>
                                                    </v-col>

                                                    <v-col
                                                        cols="12"
                                                        md="8"
                                                        align="end"
                                                        justify="end"
                                                    >
                                                        <v-btn
                                                            block
                                                            @click="confirmDeleteDiary(item)"
                                                            :disabled="!canDelete(item)"
                                                            class="error mb-2"
                                                            rounded
                                                            x-small
                                                        >
                                                            <v-icon
                                                                class="mr-2"
                                                                x-small
                                                            >
                                                                mdi-delete
                                                            </v-icon>
                                                            Remover
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </td>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>

        <v-navigation-drawer
            fixed
            left
            v-model="searching"
            hide-overlay
            width="520"
            class="pt-6"
        >
            <v-list>
                <v-list-item>
                    <v-btn
                        fab
                        small
                        color="secondary"
                        @click="searching = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                    <v-btn
                        absolute
                        right
                        small
                        color="error"
                        @click="resetFields"
                    >
                        Limpar campos
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-list class="pt-10">
                <v-form @submit.prevent="searchDiaries">
                    <v-list-item>
                        <v-autocomplete
                            :items="[
                                { text: 'Todas', value: 0 },
                                { text: 'Por aprovar', value: 1 },
                                { text: 'Aprovadas administrativo', value: 2 },
                                { text: 'Totalmente aprovadas', value: 3 },
                            ]"
                            item-text="text"
                            item-value="value"
                            label="Estado diárias"
                            dense
                            outlined
                            v-model="filter.status"
                        />
                    </v-list-item>

                    <v-list-item>
                        <v-autocomplete
                            :items="['manobrador', 'encarregado']"
                            label="Role"
                            dense
                            outlined
                            v-model="filter.role"
                        />
                    </v-list-item>

                    <v-list-item>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-menu
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="filter.start_date"
                                            label="Data inicial"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>

                                    <v-date-picker
                                        v-model="filter.start_date"
                                        :allowed-dates="(date) => date <= new Date(new Date()+1).toISOString().substr(0, 10)"
                                        @input="menu1 = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="filter.end_date"
                                            label="Data final"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>

                                    <v-date-picker
                                        v-model="filter.end_date"
                                        :allowed-dates="(date) => date <= new Date(new Date()+1).toISOString().substr(0, 10)"
                                        @input="menu2 = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-list-item>

                    <v-row
                        class="mt-10"
                        align="center"
                        justify="space-around"
                    >
                        <v-btn
                            color="primary"
                            type="submit"
                        >
                            Procurar
                        </v-btn>
                    </v-row>
                </v-form>
            </v-list>
        </v-navigation-drawer>

        <DialogConfirmation
            v-if="confirmationModal.show"
            :title="confirmationModal.title"
            type="warning"
            :opened="confirmationModal.show"
            :elevation="0"
            @on-submit="approve"
            @on-cancel="confirmationModal.item = null; confirmationModal.show = false;"
        >
            {{ confirmationModal.message }}
        </DialogConfirmation>

        <DialogConfirmation
            v-if="confirmationModalDelete.show"
            :title="confirmationModalDelete.title"
            type="warning"
            :opened="confirmationModalDelete.show"
            :elevation="0"
            @on-submit="deleteDiary"
            @on-cancel="confirmationModalDelete.item = null; confirmationModalDelete.show = false;"
        >
            {{ confirmationModalDelete.message }}
        </DialogConfirmation>

        <v-dialog
            width="80%"
            height="80%"
            v-model="previewDiary.show"
        >
            <v-card>
                <PreviewDiary
                    v-if="previewDiary.show"
                    :diary_id="previewDiary.id"
                    @close="previewDiary.show = false"
                />
            </v-card>
        </v-dialog>

        <ErrorSnackbar
            v-model="error"
            :message="error_message"
        />

        <Loader v-if="loaderWindow" />

        <v-dialog
            v-model="historico.show"
            width="50%"
        >
            <v-card>
                <v-card-title class="primary white--text">
                    Histórico de edições
                </v-card-title>

                <v-card-text>
                    <Historico
                        v-if="historico.show"
                        :versions="historico.item.versions"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Diaries from "@/api/Diaries.js"
import PDEnc from "@/api/PDEnc.js"
import Approval from "@/api/Approval.js"
import User from "@/api/User.js"
import DialogConfirmation from '@/components/UI/Modals/DialogConfirmation.vue'
import DateBetweenPicker from "@/components/UI/Inputs/DateBetweenPicker"
import PreviewDiary from "@/views/Diaries/Preview/PreviewDiary.vue"
import Tooltip from "@/components/UI/Tooltips/Tooltip"
import ErrorSnackbar from "@/components/UI/Snackbars/ErrorSnackbar"
import Loader from "@/components/UI/Loaders/Loader"
import Historico from '@/components/Diaries/Historico.vue'

export default {
    name: "DiariesV2",

    components: {
        DialogConfirmation,
        DateBetweenPicker,
        PreviewDiary,
        Tooltip,
        ErrorSnackbar,
        Loader,
        Historico
    },

    watch: {
        options: {
            immediate: false,
            handler() {
                setTimeout(() => {
                    this.searchDiaries()
                }, 10)
            },
            deep: true,
        },

        'filter.to_approved': {
            immediate: true,
            handler(val) {
                if (val == null) return

                if (val) {
                    this.filter.approved = false
                }
            }
        },

        'filter.approved': {
            handler(val) {
                if (val) {
                    this.filter.show_all = false
                }
            }
        },

        'filter.show_all': {
            handler(val) {
                if (val) {
                    this.filter.approved = false
                }
            }
        },
    },

    data() {
        return {
            error: false,

            historico: {
                item: null,
                show: false
            },

            error_message: '',
            expanded: [],
            speedDial: false,
            menu1: false,
            loaderWindow: false,
            menu2: false,
            loading: true,
            total: 0,
            searching: false,

            choices: [
                {
                    id: "eq",
                    name: "Equipamento",
                    icon: "mdi-bulldozer"
                },
                {
                    id: "mo",
                    name: "Mão de Obra",
                    icon: "mdi-hand-back-right"
                },
            ],

            headers: [
                {
                    text: 'Status',
                    sortable: false,
                    value: 'approval_status',
                    align: "center",
                },
                {
                    text: 'Obra',
                    sortable: false,
                    value: 'chave',
                    align: "center",
                },
                {
                    text: 'Data',
                    sortable: false,
                    value: 'data',
                    align: "center",
                },
                {
                    text: 'Resp. Aprovação',
                    sortable: false,
                    value: 'responsavel',
                    align: "center",
                },
                {
                    text: 'Criada Em',
                    value: 'created_at',
                    sortable: false,
                    align: "center",
                },
                {
                    text: 'Criada Por',
                    sortable: false,
                    value: 'creator',
                    align: "center",
                },
                {
                    text: 'Opções',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                },
            ],

            items: [],

            tableFooter: {
                'items-per-page-options': [5, 10, 15, 20],
                'items-per-page-text': "Linhas por página"
            },

            options: {},

            filter: {
                type: 'eq',
                start_date: null,
                end_date: null,
                role: null,
                work_id: null,
                to_approved: false,
                show_all: false,
                approved: false
            },

            confirmationModal: {
                show: false,
                title: '',
                message: '',
                approvalItem: null
            },

            confirmationModalDelete: {
                show: false,
                title: '',
                message: '',
                approvalItem: null
            },

            previewDiary: {
                id: null,
                show: false
            },

            obras_user_tem_acesso: []
        }
    },

    mounted() {
        if (!this.$store.getters.hasPermission(["super", "diaries.read"])) {
            this.$router.push('/forbidden')
        }

        this.fillBaseData()
    },

    methods: {
        parseWeather(weather) {
            if (!weather) {
                return null
            }

            try {
                return typeof weather === 'string'
                    ? JSON.parse(weather)
                    : weather
            } catch (e) {
                console.error('Erro a fazer parse do weather:', e)
                return null
            }
        },

        getWeatherIcon(weather) {
            const meta = this.parseWeather(weather)

            if (!meta || !meta.day || !meta.day.condition) {
                return null
            }

            const day = meta.day
            const conditionText = day.condition?.text || ''
            const lower = conditionText.toLowerCase()

            let icon = 'mdi-weather-partly-cloudy'

            if (
                lower.includes('chuva') ||
                lower.includes('chuvisco') ||
                lower.includes('aguace')
            ) {
                icon = 'mdi-weather-rainy'
            } else if (lower.includes('neve')) {
                icon = 'mdi-weather-snowy'
            } else if (
                lower.includes('neblina') ||
                lower.includes('nevoeiro') ||
                lower.includes('nevoa')
            ) {
                icon = 'mdi-weather-fog'
            } else if (
                lower.includes('sol') ||
                lower.includes('céu limpo') ||
                lower.includes('ceu limpo')
            ) {
                icon = 'mdi-weather-sunny'
            } else if (
                lower.includes('nublado') ||
                lower.includes('encoberto')
            ) {
                icon = 'mdi-weather-cloudy'
            }

            return icon
        },

        isDiaryRejected(item) {
            if (!item) {
                return false
            }

            return (
                item.is_rejected === true ||
                item.is_rejected === 1 ||
                item.is_rejected === '1'
            )
        },

        openHistorico(item) {
            this.historico.item = item
            this.historico.show = true
        },

        repeatCreateDiary(item) {
            const data = {
                id: item.id
            }

            PDEnc.repeatCreateDiary(data).then(() => {
                this.searchDiaries()
            })
        },

        rowClass(item){
            if(this.isDiaryRejected(item)){
                return 'row-rejected'
            }

            const classes = []

            if(item.primavera_integrated == 1 || item.primavera_integrated === true){
                classes.push('row-integrated')
            }

            const value = item.locked
            if(value != "0"){
                classes.push('row-locked')
            }

            return classes.join(' ')
        },

        fillBaseData() {
            if (
                localStorage[
                    "search-diaries-v3-" + this.$store.state.user.id
                ] != undefined
            ) {
                const data = JSON.parse(
                    localStorage[
                        "search-diaries-v3-" + this.$store.state.user.id
                    ]
                )

                this.filter = data.filter
                this.options = data.options
            }

            User.getUserObras(
                this.$store.state.user.data.id
            ).then((resp) => {
                this.obras_user_tem_acesso = resp.data
            })
        },

        openPreviewDiary(id) {
            this.previewDiary.id = id
            this.previewDiary.show = false
            this.previewDiary.show = true
        },

        resetFields() {
            this.filter = {
                type: 'eq',
                start_date: null,
                end_date: null,
                role: null,
                work_id: null
            }

            this.searchDiaries()
        },

        async approve() {
            this.loaderWindow = true

            const approval = this.confirmationModal.item

            if (approval != null) {
                await Approval.approve(approval)
                    .then(() => {
                        this.confirmationModal.item = null
                        this.confirmationModal.show = false
                        this.loaderWindow = false

                        window.location.reload()
                    })
                    .catch(() => {
                        this.loaderWindow = false
                    })

                return
            }

            this.error_message =
                'Um erro aconteceu ao aprovar a diária! Por favor tente mais tarde'

            this.error = true
            this.confirmationModal.item = null
            this.confirmationModal.show = false
        },

        confirmApprove(approval) {
            this.confirmationModal.item = approval
            this.confirmationModal.title = 'Tem a certeza?'
            this.confirmationModal.message =
                'Tem a certeza que pretende aprovar a diária?'
            this.confirmationModal.show = true
        },

        edit(item) {
            const isStandalone =
                window.matchMedia('(display-mode: standalone)').matches ||
                window.navigator.standalone

            this.$cookies.set(
                "can_approve_diary_cookie",
                this.checkIfCanApprove(item),
                "1m"
            )

            this.$cookies.set(
                "can_approve_diary_object_cookie",
                item,
                "1m"
            )

            if (item.webAppLinkHash == null) {
                window.open(
                    "/diarios/view/erp/equipment/" + item.Id,
                    isStandalone ? '_self' : '_blank'
                )

                return
            }

            if (item.creation_role == "encarregado") {
                window.open(
                    "/diarios/encarregado/editar/" +
                        item.webAppLinkHash +
                        "/" +
                        item.id_user_creator,
                    isStandalone ? '_self' : '_blank'
                )

                return
            }

            window.open(
                "/diarios/manobrador/" +
                    item.webAppLinkHash +
                    "/" +
                    item.id_user_creator +
                    '/eq',
                isStandalone ? '_self' : '_blank'
            )
        },

        checkApprovalStatus(item) {
            if (
                item.creation_role == 'encarregado' &&
                item.level_needed_to_approve == '3'
            ) {
                item.level_needed_to_approve = 2

                if (item.current_approval != null) {
                    if (item.current_approval.level == "1") {
                        item.current_approval.level = 0
                    }

                    if (item.current_approval.level == "2") {
                        item.current_approval.level = 1
                    }
                }
            }

            if (item.current_approval == null) {
                return '0 / ' + item.level_needed_to_approve
            }

            if (
                item.current_approval.level >=
                item.level_needed_to_approve
            ) {
                return 'total'
            }

            return (
                item.current_approval.level +
                ' / ' +
                item.level_needed_to_approve
            )
        },

        searchDiaries(event) {
            if (!!event && event.type == 'submit') {
                this.options.page = 1
            }

            this.loading = true

            const filter = {
                ...this.filter
            }

            const request = {
                sortBy: this.options.sortBy,
                sortDesc: this.options.sortDesc,
                page: this.options.page,
                limit: this.options.itemsPerPage
            }

            if (
                this.$store.getters.hasRole(['manobrador'])
            ) {
                this.filter.to_approved = false
                this.filter.approved = false
                this.filter.show_all = false
            }

            Object.assign(request, filter)

            this.filter.to_approved = false

            localStorage[
                "search-diaries-v3-" +
                this.$store.state.user.id
            ] = JSON.stringify({
                filter: this.filter,
                options: this.options,
            })

            Diaries.search(request).then(response => {
                const data = response.data

                this.total = data.total

                if (this.options.page > 1) {
                    const totalPages = Math.ceil(
                        this.total /
                        this.options.itemsPerPage
                    )

                    if (this.options.page > totalPages) {
                        this.options.page = 1
                    }
                }

                this.items = data.data.map(item => {
                    this.searching = false
                    return item
                })

                this.loading = false
            })
        },

        canDelete(item) {
            if (
                !this.$store.getters.hasPermission([
                    'super',
                    'diaries.delete'
                ])
            ) {
                return false
            }

            if (
                this.$store.getters.hasRole([
                    'manobrador'
                ])
            ) {
                return item.current_approval == null
            }

            if (item.webAppLinkHash == null) {
                return false
            }

            if (item.sync == true) {
                return false
            }

            return true
        },

        confirmDeleteDiary(diary) {
            this.confirmationModalDelete.item = diary
            this.confirmationModalDelete.title = 'Tem a certeza?'
            this.confirmationModalDelete.message =
                'Tem a certeza que pretende eliminar a diária?'
            this.confirmationModalDelete.show = true
        },

        deleteDiary() {
            const diary =
                this.confirmationModalDelete.item

            const params = {
                id_user_creator: diary.id_user_creator,
                id: diary.webAppLinkHash
            }

            Diaries.deleteDiary(
                params,
                diary.webAppLinkHash
            ).then(() => {
                this.success = true
                this.confirmationModalDelete.show = false
                this.searchDiaries(this.options)
            })
        },

        checkIfCanApprove(item) {
            const approval = item.current_approval

            if (
                !this.$store.getters.hasRole([
                    'encarregado',
                    'administrativo',
                    'engenheiro',
                    'parque'
                ])
            ) {
                return false
            }

            const acesso_user = []

            this.obras_user_tem_acesso.forEach(element => {
                acesso_user.push(element.Codigo)
            })

            if (!acesso_user.includes(item.chave)) {
                if (
                    !this.$store.getters.hasRole([
                        'parque'
                    ])
                ) {
                    return false
                }
            }

            if (
                parseInt(
                    item.level_needed_to_approve
                ) == 3
            ) {
                if (approval == null) {
                    if (
                        this.$store.getters.hasRole([
                            'administrativo',
                            'engenheiro',
                            'parque'
                        ])
                    ) {
                        return false
                    }

                    return true
                }

                if (
                    parseInt(
                        approval.level
                    ) == 0
                ) {
                    return this.$store.getters.hasRole([
                        'encarregado'
                    ])
                }

                if (approval.level == 1) {
                    return this.$store.getters.hasRole([
                        'administrativo'
                    ])
                }

                if (
                    parseInt(
                        approval.level
                    ) == 2
                ) {
                    if (
                        this.$store.getters.hasRole([
                            'parque'
                        ])
                    ) {
                        if (item.parque_approved) {
                            return true
                        } else {
                            return false
                        }
                    }
                }

                if (approval.level == 2) {
                    return this.$store.getters.hasRole([
                        'engenheiro'
                    ])
                }

                return false
            }

            if (
                !this.$store.getters.hasRole([
                    'administrativo',
                    'engenheiro',
                    'parque'
                ])
            ) {
                return false
            }

            if (approval == null) {
                if (
                    this.$store.getters.hasRole([
                        'engenheiro'
                    ])
                ) {
                    return false
                }

                if (
                    this.$store.getters.hasRole([
                        'parque'
                    ])
                ) {
                    return false
                }

                return true
            }

            if (
                parseInt(
                    approval.level
                ) == 0
            ) {
                return this.$store.getters.hasRole([
                    'administrativo'
                ])
            }

            if (
                parseInt(
                    approval.level
                ) == 1
            ) {
                if (
                    this.$store.getters.hasRole([
                        'parque'
                    ])
                ) {
                    if (item.parque_approved) {
                        return false
                    }

                    return true
                }
            }

            if (approval.level == 1) {
                return this.$store.getters.hasRole([
                    'engenheiro'
                ])
            }

            return false
        },
    },

    computed: {
        crumbs() {
            return [
                {
                    text: 'Consulta de diárias',
                    disabled: true,
                    to: '#',
                    exact: true,
                },
            ]
        }
    }
}
</script>

<style>
.row-locked {
  background-color: #f0f0f0 !important;
}

.filters-card {
  border-radius: 12px;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.field-label {
  font-size: 0.75rem;
  letter-spacing: .02em;
  text-transform: uppercase;
  opacity: 0.7;
}

.premium-checkbox .v-label {
  font-weight: 500;
}

.premium-checkbox .v-input--selection-controls__ripple {
  opacity: 0.12;
}

/* rejeitada = vermelho claro visível */
.v-data-table tbody tr.row-rejected,
.v-data-table tbody tr.row-rejected > td {
  background-color: #f8d7da !important;
}

.v-data-table tbody tr.row-rejected:hover,
.v-data-table tbody tr.row-rejected:hover > td {
  background-color: #f1bfc5 !important;
}

/* integrada = cinza */
.v-data-table tbody tr.row-integrated,
.v-data-table tbody tr.row-integrated > td {
  background-color: #e6e6e6 !important;
}

.row-integrated td {
  opacity: 0.85;
}
</style>